<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.30566"
      y="0.837646"
      width="16"
      height="16"
      rx="4.5"
      stroke="currentColor"
    />
    <path
      d="M8.36674 4.89873H10.4811C11.2382 4.89873 11.9091 5.05876 12.4939 5.37884C13.0817 5.69892 13.5418 6.14979 13.8742 6.73147C14.2097 7.31007 14.3774 7.99023 14.3774 8.77195C14.3774 9.52905 14.2097 10.1892 13.8742 10.7524C13.5418 11.3156 13.0817 11.7542 12.4939 12.0681C11.9091 12.379 11.2382 12.5344 10.4811 12.5344H8.36674C7.60656 12.5344 6.93256 12.3805 6.34473 12.0727C5.7569 11.7619 5.29525 11.3249 4.95978 10.7617C4.6274 10.1984 4.4612 9.53367 4.4612 8.76733C4.4612 7.98561 4.62894 7.30545 4.9644 6.72685C5.30294 6.14517 5.76613 5.69584 6.35396 5.37884C6.94179 5.05876 7.61272 4.89873 8.36674 4.89873ZM8.36674 6.56989C7.96049 6.56989 7.60195 6.65145 7.2911 6.81456C6.98334 6.9746 6.74328 7.21774 6.57093 7.54397C6.39859 7.8702 6.31241 8.27799 6.31241 8.76733C6.31241 9.23514 6.40012 9.62446 6.57555 9.9353C6.75405 10.2461 6.99719 10.4785 7.30495 10.6324C7.61272 10.7863 7.96665 10.8632 8.36674 10.8632H10.4949C10.8981 10.8632 11.2505 10.7847 11.5521 10.6278C11.8568 10.4708 12.0922 10.2369 12.2584 9.92607C12.4277 9.61523 12.5123 9.23052 12.5123 8.77195C12.5123 8.2826 12.4277 7.87481 12.2584 7.54858C12.0922 7.22235 11.8568 6.97768 11.5521 6.81456C11.2505 6.65145 10.8981 6.56989 10.4949 6.56989H8.36674ZM10.3703 3.71691V13.7254H8.47292V3.71691H10.3703Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconFranchiseFilial',
  }
</script>

<style scoped lang="less">

</style>
